import * as api from './Api';
import * as utils from './Utils';


function extractProductExternalId() {
  let ovData = window.OnVoardData;
  if (!ovData) return;

  if (ovData.ecommerce_platform === "shopify") {
    const template = ovData.template;
    const product = ovData.product;
    if (template !== "product" || !product) return;
    return product.id;
  }

  if (ovData.ecommerce_platform === "bigcommerce") {
    const pageType = ovData.page_type;
    const product = ovData.product;
    if (pageType !== "product" || !product) return;
    return product.id;
  }

  if (ovData.ecommerce_platform === "easystore") {
    const template = ovData.template;
    const product = ovData.product;
    if (template !== "product" || !product) return;
    return product.id;
  }

  if (ovData.ecommerce_platform === "shopline") {
    const product = ovData.product;
    if (!product || !product.id) return;
    return product.id;
  }

  if (ovData.ecommerce_platform === "shopware") {
    const product = ovData.product;
    if (!product || !product.id) return;
    return product.id;
  }

  if (ovData.ecommerce_platform === "wix") {
    const pageType = ovData.page_type;
    const product = ovData.product;
    if (pageType !== "product" || !product) return;
    return product.id;
  }

  if (ovData.ecommerce_platform === "woocommerce") {
    const pageType = ovData.page_type;
    const product = ovData.product;
    if (pageType !== "product" || !product) return;
    return product.id;
  }

  return;
}

function trackClick(qs, cookieId, productExternalId) {
  if (!qs['ov_recommender']) return;

  let clickedRecommenderId = decodeURIComponent(qs['ov_recommender']);
  if (!clickedRecommenderId) return;

  let payload = {};
  payload['recommender'] = clickedRecommenderId;
  payload['cookie_id'] = cookieId;
  payload['ecommerce_platform'] = utils.getEcommercePlatform();
  payload['platform_identifier'] = utils.getPlatformIdentifierForEngagement();
  if (productExternalId) payload['product_external_id'] = productExternalId;

  const successCallback = (response) => {};
  const errorCallback = (error) => {
    console.error(error);
  };

  api.postRecommenderTrackClick(successCallback, errorCallback, JSON.stringify(payload));
}


function trackRecentlyViewed(accountId, cookieId, productExternalId) {
  if (!cookieId || !productExternalId) return;

  let payload = {};
  payload['account_id'] = accountId;
  payload['cookie_id'] = cookieId;
  payload['product_external_id'] = productExternalId;

  const successCallback = (response) => {};
  const errorCallback = (error) => {
    console.error(error);
  };

  api.postRecommenderTrackRecentlyViewed(successCallback, errorCallback, JSON.stringify(payload));
}


export function processTracking() {
  if (!utils.isBrowser()) return;

  let ovData = window.OnVoardData;
  const platform = utils.getEcommercePlatform();
  const el = document.querySelector(".ov-app-recommender-tracking");
  if (!el) return;

  let accountId = el.getAttribute('data-account-id');
  if (!accountId && platform === 'shopline') {
    if (ovData && ovData.config) {
      accountId = ovData.config['account_id'];
    }
  }

  if (accountId && !el.getAttribute('data-account-id')) {
    el.setAttribute("data-account-id", accountId);
  }

  const qs = utils.parseQueryString(window.location.search);
  const cookieId = utils.getOrCreateCookieId();
  const productExternalId = extractProductExternalId();

  // track click
  trackClick(qs, cookieId, productExternalId);

  // track recently viewed
  trackRecentlyViewed(accountId, cookieId, productExternalId);
};

